module.exports = __webpack_public_path__ + "static/img/detail-bg-right.950b24f7.png";